(($, Drupal, drupalSettings) => {

  // Vanilla versions of wrap and unwrap
  const unWrap = (els) => {
    els.forEach( el => {
      var parent = el.parentNode;
      while (el.firstChild) parent.insertBefore(el.firstChild, el);
      parent.removeChild(el);
    });
  },
  wrap = (els) => {
    els.forEach( elem => {
      const div = document.createElement('span');
      div.style.display = '';
      elem.parentElement.insertBefore(div, elem);
      div.appendChild(elem);
    });
  }

  Drupal.behaviors.filterAvailableTimes = {

    attach: (context, settings) => {
      const maybeShowEmptyMessages = (e) => {
        // Show dropdown elements & booking button if API returns available times.
        if(Object.keys(e.reason).length !== 0 || Object.keys(e.employees).length !== 0) {
          document.querySelectorAll('.office-booking').forEach( bookingElement => {
            bookingElement.classList.remove('hidden-important');
          });
        }
        // Show notification if no available times.
        else {
          document.querySelector('.no-available-times').classList.remove('hidden-important');
        }
      }

      const deleteElements = e => {
        document.querySelectorAll('.office-booking').forEach( bookingElement => {
          var service = bookingElement.querySelector('.service-select');

          const gatherDeletedItems = (obj,sel) => {
            var options = bookingElement.querySelector(sel).options;
            var val, i, r = [];
            for( i = 0; i < options.length; i++ ){
              val = options[i].value;
              if((val !== 'none' && val !== 'other') && obj[options[i].value] === undefined ){
                r.push( options[i] );
              }
            }
            return r;
          }

          var deletepointer = gatherDeletedItems(e.reason, '.service-select');
          deletepointer = deletepointer.concat( gatherDeletedItems(e.employees, '.user-select') );

          deletepointer.forEach( pointer => {
            pointer.parentNode.removeChild(pointer);
          });

        });
      }

      // $(context.querySelectorAll('.node--type-office.node--view-mode-header')).once('filterAvailableTimes').each( (index, office) => {
      $(once('filterAvailableTimes', '.node--type-office.node--view-mode-header')).each( (index, office) => {  
        new Drupal.assisDentCaller().getBranchAvailableTimes([office.dataset.branchUuid], e => {
          // First check empty elements and delete all the elements that arent
          // in any office.
          maybeShowEmptyMessages(e);
          deleteElements(e);
        });
      });

      // $(context.querySelectorAll('.node--type-chain-page.node--view-mode-header')).once('filterAvailableTimes').each( (index, office) => {
      $(once('filterAvailableTimes', '.node--type-chain-page.node--view-mode-header')).each( (index, office) => {
        const branchUUIDs = JSON.parse(office.dataset.branchUuids);
        new Drupal.assisDentCaller().getBranchAvailableTimes(branchUUIDs, e => {

          // First check empty elements and delete all the elements that arent
          // in any office.
          maybeShowEmptyMessages(e);
          deleteElements(e);

          // Find the branch switch.
          var perBranchTimes = [];

          $(document.querySelectorAll('.branch-select')).each( (index,branchSelect) => {

            // Get drupal generated selection narrower.
            var selectionNarrower = JSON.parse(branchSelect.dataset.crossSelectionNarrower);

            // Now we need to get current times for each branch.
            for( var x = 0; x < branchSelect.options.length; x++){
              const bUUID = branchSelect.options[x].value;
              // Just to make sure we got right size uuid.
              if (bUUID.length === 36) {
                new Drupal.assisDentCaller().getBranchAvailableTimes([bUUID], e => {

                  // Make just checks that we dont got empty elements
                  // get the keys only becouse that is only needed
                  // and add them to correct object positions.
                  if (Object.keys(e.reason).length !== 0) {
                    selectionNarrower[bUUID]['service-select'] = Object.keys(e.reason);
                  }
                  if (Object.keys(e.employees).length !== 0) {
                    selectionNarrower[bUUID]['user-select'] = Object.keys(e.employees);
                  }
                });
              }
            }

            // Time to listen events from select.
            branchSelect.addEventListener('change', (event) => {
              // Make variables last for evah.
              const thisElement = event.target,
                    thisNarrowed = selectionNarrower[thisElement.value];

              // Go trough all keys from narrower.
              Object.keys(selectionNarrower[branchSelect.value]).forEach( key => {
                var elem = document.querySelector('.' + key);
                // Oh mi got, we got element associated tot the key, MAGICK.
                if (elem) {

                  // Create temp array to preserve not wanted elements.
                  var hidedElements = [];

                  // Unwrap elements that are wrapped.
                  unWrap(thisElement.querySelectorAll('span'));

                  if (thisElement.value == 'none') {
                    return;
                  }

                  // Gather all the options that arent in the narrower.
                  for (var i = 0; i < elem.options.length; i++) {
                    var val = elem.options[i].value;
                    if (val != 'none' && val != 'other' && thisNarrowed[key].indexOf(val) === -1) {
                      hidedElements.push(elem.options[i]);
                    }
                  }

                  // and finally wrap options with ugly span to hide them.
                  wrap(hidedElements);
                }
              })
            });
          });
        });
      });
    }
  }
})(jQuery, Drupal, drupalSettings);
